import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M12 23C5.92487 23 1 18.0751 1 12C1 5.92487 5.92487 1 12 1C18.0751 1 23 5.92487 23 12C23 18.0751 18.0751 23 12 23ZM10.9996 9.04019L7.61829 7.13818L6.63776 8.88133L8.45877 9.90565L6.59961 11.3L7.79961 12.9L10.9996 10.5L10.9996 9.04019ZM15.5404 9.90565L17.3614 8.88133L16.3809 7.13818L12.9996 9.04019L12.9996 10.5L16.1996 12.9L17.3996 11.3L15.5404 9.90565ZM11.9996 19C14.761 19 16.9996 16.7614 16.9996 14H6.9996C6.9996 16.7614 9.23818 19 11.9996 19Z"}}]};

const JoyfulFilled = Vue.extend<IconProps>({
  name: 'JoyfulFilledIcon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'joyful-filled',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default JoyfulFilled;
